import { ALL_BRANDS_URL, BRANDS_URL, DEALERS_URL, GROUPS_URL } from 'constants/ApiConstants';
import * as types from 'modules/brands/actionsType';

import type * as BrandTypes from '../types';

export const fetchBrand = (brandId: string): BrandTypes.FetchBrandAction => ({
  type: types.FETCH_BRAND_REQUEST,
  payload: {
    brandId,
    request: { method: 'GET', url: `${BRANDS_URL}/${brandId}` },
  },
});

export const fetchAllBrands = (params?: BrandTypes.BrandQueryParams): BrandTypes.FetchAllBrandsAction => ({
  type: types.FETCH_ALL_BRANDS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: ALL_BRANDS_URL,
      params: {
        fields: 'id,name,type,templated',
        sort: 'name,asc',
        ...params,
      },
    },
  },
});

export const fetchBrandsByDealer = (
  dealerId: string,
  params?: BrandTypes.BrandQueryParams
): BrandTypes.FetchBrandsByDealerAction => ({
  type: types.FETCH_BRANDS_BY_DEALER_REQUEST,
  payload: {
    dealerId,
    request: {
      method: 'GET',
      url: `${DEALERS_URL}/${dealerId}/brands`,
      params,
    },
  },
});

export const fetchBrandsByDealerSuccess = (
  brands: Array<BrandTypes.Brand>,
  dealerId: string
): BrandTypes.FetchBrandsByDealerSuccessAction => ({
  type: types.FETCH_BRANDS_BY_DEALER_SUCCESS,
  payload: {
    brands,
    dealerId,
  },
});

export const fetchBrandsByGroup = (
  groupId: string,
  params?: BrandTypes.BrandQueryParams
): BrandTypes.FetchBrandsByGroupAction => ({
  type: types.FETCH_BRANDS_BY_GROUP_REQUEST,
  payload: {
    groupId,
    request: {
      method: 'GET',
      url: `${GROUPS_URL}/${groupId}/brands`,
      params,
    },
  },
});

export const fetchBrandsByGroupSuccess = (
  brands: Array<BrandTypes.Brand>,
  groupId: string
): BrandTypes.FetchBrandsByGroupSuccessAction => ({
  type: types.FETCH_BRANDS_BY_GROUP_SUCCESS,
  payload: {
    brands,
    groupId,
  },
});
